module.exports = "   /* unvisited link */\r\n   a:link {\r\n    color:#424242;\r\n  }\r\n   /* visited link */\r\n   a:visited {\r\n    color: #673AB7;\r\n  }\r\n   /* mouse over link */\r\n   a:hover {\r\n    color: #7C4DFF;\r\n  }\r\n   /* selected link */\r\n   a:active {\r\n    color: #673AB7;\r\n  } "


//////////////////
// WEBPACK FOOTER
// ./src/app/toolbar-header/toolbar-header.component.css
// module id = ./src/app/toolbar-header/toolbar-header.component.css
// module chunks = main